import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Container = styled.div`
  height: 100%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  min-width: 320px;
  position: relative;
  input {
    color: #fff;
    background-color: transparent;
    border: 1px solid #CC92FE;
    border-radius: 16px;
    padding: 10px;
    &:focus {
      background-color: transparent;
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
      -webkit-box-shadow: 0 0 0 30px transparent inset;
      -webkit-text-fill-color: #fff;
      transition: background-color 5000s ease-in-out 0s;
    }
  }
  label {
    color: #fff;
  }
  
  ${media.greaterThan('large')`
    grid-template-columns: repeat(2, 1fr);
  `}
`

export const TemplateImage = styled.div`
  ${() => css`
    position: fixed;
    left: 0;
    top: 0;
    right: 50vw;
  `}
`

export const Image = styled.img`
  ${() => css`
    height: 100vh;
    width: 100%;
  `}
`

export const TemplatePage = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
`

export const BackgroundVideo = styled.video`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  object-position: center;
  z-index: -1;
`
